import { alias, deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../../api";

interface IProps {
	id?: number;
	code?: string;
	name?: string;
	isElearning?: boolean;
}

export class Library {
	public static fromJson(json: IJsonObject): Library {
		return deserialize(Library, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Library[] {
		return json.map((library: IJsonObject) => this.fromJson(library));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public code: string;

	@serializable
	public name: string;

	@serializable(alias("is_elearning"))
	public isElearning: boolean;

	constructor({
		id = 0,
		code = "",
		name = "",
		isElearning = false,
	}: IProps = {}) {
		this.id = id;
		this.code = code;
		this.name = name;
		this.isElearning = isElearning;
	}
}
